"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@mui/styles");
const local_storage_util_1 = require("../@common/util/local-storage-util");
const i18n_util_1 = require("../@common/util/i18n-util");
const style_util_1 = require("../@common/util/style-util");
const translateErrors = key => i18n_util_1.translate('lwt-lib-a11ySettings', key);
const LIGHT_GREEN = '#31AA39';
const Page404 = ({ goToLabel = translateErrors('goHome'), goToRoute = '/home', imgSrc = i18n_util_1.getTranslatedImage('404-sorry-kid.png'), theme = LIGHT_GREEN }) => {
    const classes = useStyles({ color: theme });
    return (react_1.default.createElement("div", { className: classes.outerContainer },
        react_1.default.createElement("div", { className: classes.imgContainer },
            react_1.default.createElement("img", { className: classes.img, src: imgSrc, alt: translateErrors('404ImgAlt') })),
        react_1.default.createElement("section", { className: classes.textSection },
            react_1.default.createElement("span", { className: classes.span }, translateErrors('404Title')),
            react_1.default.createElement("h1", { className: classes.heading1 }, translateErrors('notFound')),
            react_1.default.createElement("h2", { className: classes.heading2 }, translateErrors('cantFind')),
            react_1.default.createElement("div", { className: classes.link },
                react_1.default.createElement("a", { className: classes.anchor, href: goToRoute, onClick: local_storage_util_1.clear }, goToLabel)))));
};
const useStyles = styles_1.makeStyles((theme) => ({
    anchor: {
        backgroundColor: ({ color }) => color,
        borderRadius: '5px',
        color: theme.palette.primary.contrastText,
        fontSize: style_util_1.remCalc(14),
        marginTop: style_util_1.remCalc(10),
        padding: `${style_util_1.remCalc(5)} ${style_util_1.remCalc(20)}`,
        textDecoration: 'none'
    },
    heading1: {
        fontSize: '3.5rem',
        fontWeight: 500,
        margin: '0.5rem 0'
    },
    heading2: {
        fontSize: '1.5rem',
        fontWeight: 300,
        margin: 0
    },
    img: {
        height: style_util_1.remCalc(550)
    },
    imgContainer: {
        height: '70%',
        marginRight: '5%'
    },
    link: {
        margin: '1.2rem 0'
    },
    outerContainer: {
        alignItems: 'center',
        backgroundColor: theme.palette.primary.contrastText,
        display: 'flex',
        flexDirection: 'row',
        fontFamily: 'GSS Futura',
        fontSize: '1.2rem',
        justifyContent: 'center',
        height: '100%',
        width: '100%'
    },
    span: {
        fontSize: '1.3rem',
        fontWeight: 300
    },
    textSection: {
        position: 'relative',
        top: '-6%'
    }
}));
exports.default = Page404;
